import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import DocumentList from '@/components/document-menu/document-list';
import PanelTitle from '@/components/document-menu/panels/panel-title';
import {Document} from '@/interfaces/document';

interface ElementProps {
  documents: Document[];
  closeMenu: () => void;
}

const PanelSent: FunctionComponent<ElementProps> = ({documents, closeMenu}) => {
  const {t} = useTranslation();

  return (
    <>
      <PanelTitle title={t('components.document-menu.panels.sent.title')} />

      <DocumentList
        linksDisabled={true}
        documents={documents}
        emptyResultMessage={t('components.document-menu.panels.sent.no-result-message')}
        onItemClick={closeMenu}
      />
    </>
  );
};

export default PanelSent;
